// @ts-nocheck
import { InitPage } from "../../index";

declare var setPrinterUrl: string;
declare var reprintLabelUrl: string;
declare var printPlateUrl: string;
declare var validatePrintUrl: string;
declare var maxPrintExceptionUrl: string;
declare var printItemNumber: string;

class Generate {
  constructor() {
    $("#lot_date, #expiration_date").datepicker({
      format: "yyyy-mm-dd HH:ii p",
    });

    $("#exp-date, #lot-date").on("click", function (e) {
      e.preventDefault();
      $(this).datepicker("show");
    });

    $(".view_details").on("click", (e) => {
      $("#json_data").html(e.currentTarget.dataset.json);
      $("#showDetails").modal("show");
    });

    $("#checkAll").on("click", () => {
      const checked = $("#checkAll").is(":checked");
      $.each($(".tag:enabled"), function () {
        $(this).prop("checked", checked);
      });
    });

    $("#checkAll, .tag").on("click", () => {
      if ($(".tag:checked").length === 0) {
        $("#print_lic_plate").attr("disabled", "disabled");
        $("#print_lic_plate").addClass("disabled");
        $("#print_rfid_label").attr("disabled", "disabled");
        $("#print_rfid_label").addClass("disabled");
      } else {
        $("#print_lic_plate").removeAttr("disabled");
        $("#print_lic_plate").removeClass("disabled");
        $("#print_rfid_label").removeAttr("disabled");
        $("#print_rfid_label").removeClass("disabled");
      }
    });

    $("#print-submit").on("click", function () {
      const form = $(this).closest("form");
      const palletCount = parseInt($("#pallet_count").val() as string);
    
      if (palletCount > 100) {
        // Show error message if palletCount is greater than 100
        swal({
          title: "Error",
          text: "It’s more than 100 pages. The system has a maximum limit of 100 pages. Please contact Senitron support if you would like to increase this limit.",
          icon: "error",
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "Close",
              value: null,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-silver",
              closeModal: true,
            },
          },
          dangerMode: true,
        });
      } else if (palletCount > 20) {
        // Show SweetAlert confirmation
        swal({
          title: "Was this intentional?",
          text: `Are you sure you want to print ${palletCount} pages?`,
          icon: "warning",
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "No",
              value: null,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-silver",
              closeModal: true
            },
            confirm: {
              text: "Yes",
              value: true,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-red",
              closeModal: true
            },
          },
          dangerMode: true,
        }).then((willProceed) => {
          if (willProceed) {
            // Proceed with form validation and submission if user confirms
            if (form.valid()) {
              $(this).attr("disabled", true);
              $(this).addClass("disable_link hover-cursor-not-allowed");
            }
            $("#print-submit-btn").trigger("click");
          }
        });
      } else {
        // If pallet_count is 20 or less, proceed with normal submission
        if (form.valid()) {
          $(this).attr("disabled", true);
          $(this).addClass("disable_link hover-cursor-not-allowed");
        }
        $("#print-submit-btn").trigger("click");
      }
    });
    

    // Check the Max Print Units / Max Print Value thresholds before the form is
    // allowed through, so a breach shows the print exception modal rather than
    // queueing a job that fails out of sight in the worker.
    let printValidated = false;

    const releasePrintButton = () => {
      $("#print-submit")
        .removeAttr("disabled")
        .removeClass("disable_link hover-cursor-not-allowed");
    };

    $("#print-tag-form").on("submit", function (e) {
      if (printValidated) {
        return true;
      }

      e.preventDefault();

      $.ajax({
        type: "POST",
        url: validatePrintUrl,
        data: {
          item_number: printItemNumber,
          pallet_count: $("#pallet_count").val(),
          box_count: $("#box_count").val(),
          unit_count: $("#unit_count").val(),
          uom: $("#uom").val(),
        },
        success: (resp) => {
          if (resp.success) {
            // Back through the button so HTML5 and jQuery validation still run.
            printValidated = true;
            $("#print-submit-btn").trigger("click");
          } else {
            releasePrintButton();
            $.get(maxPrintExceptionUrl);
          }
        },
        error: () => {
          releasePrintButton();
          swal(
            "Error(s) in processing:",
            "Something went wrong, please contact support",
            "error",
            { className: "swal-blue-color-for-ok" },
          );
        },
      });

      return false;
    });

    // When changing the selected printer auto-save it to the server
    $("#printer_id").on("change", (e) => {
      $.ajax({
        url: setPrinterUrl,
        method: "POST",
        data: { printer: $(e.target).val() },
      });
      setTimeout(() => history.go(0), 1500);
    });

    $("#print_rfid_label").on("click", (_e) => {
      if (selected_ids().length == 0) {
        return;
      }
      window.location.href = `${reprintLabelUrl}?ids[]=${selected_ids().join(
        "&ids[]=",
      )}`;
    });

    $("#print_lic_plate").on("click", (_e) => {
      if (selected_ids().length == 0) {
        return;
      }
      window.location.href = `${printPlateUrl}?ids[]=${selected_ids().join(
        "&ids[]=",
      )}`;
    });

    $("#pallet_count, #box_count, #unit_count, #uom").on(
      "keyup, change",
      (_e) => {
        let labels = 1;
        let qty = 1;

        const palletCount = $("#pallet_count").val();
        const boxCount = $("#box_count").val();
        const unitCount = $("#unit_count").val();
        const uom = $("#uom").val() || "";

        if (palletCount.length) {
          labels = palletCount;
          qty = parseInt(boxCount || "1", 10) * parseInt(unitCount || "1", 10);
        } else if (boxCount.length) {
          labels = boxCount;
          qty = unitCount || "1";
        } else {
          labels = unitCount || "1";
        }

        $("#print-message").html(
          `${labels} Label(s) will be printed with QTY ${qty} ${uom}`,
        );
      },
    );

    function selected_ids() {
      const values = [];
      $.each($(".tag:checked"), function () {
        values.push($(this).val());
      });
      return values;
    }
  }
}

export function LoadPage() {
  InitPage("generate", () => {
    new Generate();
  });
}
